module.exports = __webpack_public_path__ + "img/gpt.8d60d0b1.png";